// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eMSUs","question":"styles_question__2goTi","description":"styles_description__3CUjb"};